import { render } from "./Create25Liquidation4.vue?vue&type=template&id=0fca62c8"
import script from "./Create25Liquidation4.vue?vue&type=script&lang=js"
export * from "./Create25Liquidation4.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__